var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCreation)?_c('layout',[_c('router-view')],1):_c('container',[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }